import { makeStyles } from '@material-ui/styles'

export const useStudentListShellStyles = makeStyles(theme => ({
  tableShell: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  searchGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '1 1 0',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      width: '100%',
    },
  },
  searchField: {
    flex: '1 1 0',
    minWidth: 0,
    maxWidth: 360,
    width: '100%',
  },
  toolbarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  tableContent: {
    padding: theme.spacing(0, 1, 1),
    [theme.breakpoints.down('xs')]: {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      '& table': {
        minWidth: 560,
      },
    },
  },
  listEmptyStateContent: {
    padding: theme.spacing(4, 2),
  },
}))
